import React, { useEffect, useRef, useState } from "react";
import html2pdf from "html2pdf.js";
import { licenseQR } from "../../auth/services/privateapicalling";
import { useSelector } from "react-redux";

interface DownloadGCA {
  application: any;
}

const GcaLicenseDownload: React.FC<DownloadGCA> = ({ application }) => {
  const pdfRef = useRef<HTMLDivElement>(null);
  const [loading, setLoading] = useState(false);
    const token = useSelector((state: any) => state.auth.token);
 const [qrUrl , setQrUrl] = useState();
  const handleDownloadPDF = async () => {
    if (!pdfRef.current) return;
    setLoading(true);

    const clonedContent = pdfRef.current.cloneNode(true) as HTMLElement;
    clonedContent.style.display = "block";

    html2pdf()
      .from(clonedContent)
      .save("GCA_License.pdf")
      .then(() => setLoading(false));
  };

  const fetchLicenseQr = async()=>{
    const body ={
      name: application?.applicantName,
      applicationId: application?.applicationId,
      email: application?.regEmailId,
      licenseNo: application?.licenseNo
    }
    try {
      const res = await licenseQR(body , token);
    
      setQrUrl(res.qrCode);
    } catch (error) {
    
    }
  }
  // Extract data from application prop
  const data = application?.application || {};

useEffect(()=>{
 fetchLicenseQr();
  
},[qrUrl])

  return (
    <div className="text-center">
      {/* Hidden content for PDF */}
      <div
        ref={pdfRef}
        style={{
          display: "none",
          width: "100%",
          padding: "40px",
          backgroundColor: "white",
          fontFamily: "Noto Sans Gujarati, serif",
          color: "#000000",
        }}
      >
        
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" , marginBottom:"15px", padding: "2px",  width: "100%", }}>
          
          {/* ✅ QR Code */}
          {/* <div >
            <QRCodeCanvas value="https://reactjs.org/" style={{ width: 100, height: 100 }} />
          </div> */}
          
          {qrUrl && (
              <div className="">
                <img src={qrUrl} alt="QR Code"  style={{ width: '100px', height: '100px' }} />
              </div>
            )}

            {/* Header */}
        <div className="text-center mb-5">
          <h1 className="fs-3 fw-bold text-decoration-underline mb-5 text-dark">
            કમિશન એજન્‍ટ તરીકે કામ કરવા માટે લાઇસન્સ
          </h1>
        </div>

          {/* ✅ Another Image */}
	  <img src="assets/img/home/profile_img_license.jpg" alt="Photo" style={{ height: "100px" }} />
        </div>
     
        <div className="text-center mb-6">
          <h2
            className="fw-bold text-decoration-underline mb-3 text-dark"
            style={{ fontSize: "20px" }}
          >
            કમિશન એજન્‍ટ તરીકે કામ કરવા માટે લાઇસન્સ
          </h2>
        </div>
<div className="row mb-3">
  <div className="col-md-6 text-start">
    <label className="form-label">ઠરાવ નંબર :</label>{" "}
    <span>{application?.resolutionNumber}</span>
  </div>

  <div className="col-md-6 text-end">
    <label className="form-label">ઠરાવની તારીખ :</label>{" "}
    <span>{application?.approvalDate}</span>
  </div>
</div>

        {/* Form Fields */}
        <div className="mb-4">
          <div className="d-flex mb-3">
            <span style={{ width: "120px" }}>લાયસન્સનો ક્રમાંક:-</span>
            <span className="flex-fill ps-1">
              {application?.licenseNo
                ? application?.licenseNo
                : "..............................................................."}
            </span>
          </div>

          <div className="d-flex mb-3">
            <span style={{ width: "160px" }}>લાયસન્સ ધરાવનારનું નામ:-</span>
            <span className="flex-fill ps-1">
              {application?.applicantName
                ? application?.applicantName
                : "..............................................................."}
            </span>
          </div>

       {application?.partnerDetails?.length > 0 &&   <div className="d-flex mb-3">
            <span style={{ width: "160px" }}>પ્રોપરાઈટર/પાર્ટનરનું નામ:-</span>
            <span className="flex-fill ps-1">
              {application?.partnerDetails?.length > 0
                ? application?.partnerDetails?.map((partner) => partner?.partnerName).join(", ")
                : "..............................................................."}
            </span>
          </div>}

          <div className="d-flex flex-wrap mb-3">
            <span style={{ width: "80px" }}>સરનામું:</span>
            <span className="flex-fill ps-1" style={{ minWidth: "120px" }}>
              {application?.currAddress?.[0]?.at || ""}{" "}
              {application?.currAddress?.[0]?.taluka || ""}{" "}
              {application?.currAddress?.[0]?.district || ""}
            </span>
          
          </div>

          <div className="d-flex gap-2 mb-3">
            <span>પો</span>
            <span style={{ width: "120px" }} className="ps-1">
              {application?.regOffAddress?.[0]?.at ||
                "........................"}
            </span>
            <span>તાલુકો</span>
            <span style={{ width: "120px" }} className="ps-1">
              {application?.regOffAddress?.[0]?.taluka ||
                "........................"}
            </span>
            <span>જિ</span>
            <span style={{ width: "120px" }} className="ps-1">
              {application?.regOffAddress?.[0]?.district ||
                "........................"}
            </span>
          </div>

          <div className="d-flex mb-4">
            <span style={{ width: "80px" }}>લાયસન્સ ફી :-</span>
            <span className="flex-fill ps-1">
              {application?.paymentFees
                ? application.paymentFees
                : "..............................................................."}
            </span>
          </div>
        </div>

        {/* Directors/Partners Section */}
       {/* <div className="mb-5">
          <p className="fw-semibold mb-4">
            અરજદાર પેઢીના ડાયરેકટરો/ભાગીદારો/મદદનીશો/અગર પ્રતિનિધિઓના નામ:-
          </p>
          {[0, 1, 2, 3, 4].map((index) => (
            <div key={index} className="d-flex mb-2">
              <span style={{ width: "32px" }}>{index + 1}.</span>
              <span className="flex-fill ps-1">
                ...............................................................
              </span>
            </div>
          ))}
        </div> */}
        <div className="mb-5">
  <p className="fw-semibold mb-4">
    અરજદાર પેઢીના ડાયરેકટરો/ભાગીદારો/મદદનીશો/અગર પ્રતિનિધિઓના નામ:-
  </p>

  {application?.representatives?.length > 0 ? (
    application.representatives.map((partner, index) => (
      <div key={index} className="d-flex mb-2">
        <span style={{ width: "32px" }}>{index + 1}.</span>
        <span className="flex-fill ps-1">
          {partner.name}{" "}
          {partner.age ? `(${partner.age} yrs)` : ""}{" "}
          {partner.address || ""}
        </span>
      </div>
    ))
  ) : (
    // fallback if no partners
    <div className="d-flex mb-2">
      <span style={{ width: "32px" }}>1.</span>
      <span className="flex-fill ps-1">
        ...............................................................
      </span>
    </div>
  )}
</div>


        {/* Bank Accounts Section */}
        <div className="mb-5">
          <p className="fw-bold mb-5">
            અરજદાર દ્વારા જાહેર કરાયેલા નીચેના બેંક ખાતાઓને કમિશન એજન્‍ટના
            લાઇસન્સની શરતો અને નિયમો હેઠળ ટ્રેડિંગ પ્રવૃત્તિઓ માટે પરવાનગી
            આપવામાં આવે છે.
          </p>

          <table className="table table-bordered w-100">
  <thead>
    <tr>
      <th className="fw-bold border p-2 bg-transparent text-center">No.</th>
      <th className="fw-bold border p-2 bg-transparent text-center">Acc. No.</th>
      <th className="fw-bold border p-2 bg-transparent text-center">Bank Name</th>
      <th className="fw-bold border p-2 bg-transparent text-center">Branch</th>
      <th className="fw-bold border p-2 bg-transparent text-center">IFSC CODE</th>
    </tr>
  </thead>
  <tbody>
    <tr>
      <td className="border p-2 text-center">1</td>
      <td className="border p-2 text-center">{application?.bankDetails[0]?.acct_no}</td>
      <td className="border p-2 text-center">{application?.bankDetails[0]?.bank_name}</td>
      <td className="border p-2 text-center">{application?.bankDetails[0]?.branch_name}</td>
      <td className="border p-2 text-center">{application?.bankDetails[0]?.ifsc_code}</td>
    </tr>
  </tbody>
</table>

        </div>

        {/* Main Paragraph */}
        <div className="mb-5 text-justify">
          <p>
            જે-તે વર્ગની ઠરાવેલ મર્યાદામાં રહીને ગુજરાત ખેત ઉત્પન્ન અને
            ખરીદ-વેચાણ (ઉત્તેજન અને સરલીકરણ) અધિનિયમ, ૧૯૬૩ અને ગુજરાત એગ્રીકલ્ચર
            માર્કેટ રૂલ્સ, ૧૯૬૫ના નિયમો અને તે અન્વયેની જોગવાઈઓ આધીન નીચેની
            શરતોએ મુખ્ય માર્કેટ યાર્ડ / સબ માર્કેટ યાર્ડમાં નિયંત્રીત
            ખેતપેદાશોના ખરીદ-વેચાણનો ધંધો કરવા આથી લાયસન્સ આપવામાં આવે છે.
          </p>
        </div>

        {/* Secretary Signature */}

         <div className="d-flex justify-content-end">
          <div className="text-center">
            <p className="fw-bold">સેક્રેટરી</p>
            <p className="fw-bold">
              ખેતીવાડી ઉત્પન્ન બજાર સમિતિ , {application?.apmc ? application.apmc : "........"}
            </p>
          </div>
        </div>

        {/* Terms and Conditions */}
        <div className="mb-4 mt-2"style={{
    pageBreakBefore: "always",   // forces new page in PDF
 
  }}>
    <div className="" style={{height:"1px", width:"1px"}}></div>
          <h2
            className=" fw-bold text-decoration-underline mb-3 mt-1 text-center text-dark"
            style={{fontSize:"18px"}}
          >
            કમિશન એજન્‍ટના લાઇસન્સની શરતો
          </h2>

          <div className="text-justify lh-sm">
            <p className="mb-3">
              1. લાઐસન્સધારક ઉપરોક્ત અધિનિયમ અને નિયમોની જોગવાઈઓ અને ખેતીવાડી
              ઉત્પન્ન બજાર સમિતિ દ્વારા કરવામાં આવેલ કરારની શરતોનું પાલન કરશે.
            </p>

            <p className="mb-3">
              2. લાઇસન્સ ટ્રાન્સફરપાત્ર નથી. લાયસન્સ જે નામે હશે તે જ નામે
              વેપાર-ધંધો કરી શકાશે.
            </p>

            <p className="mb-3">
              3. આ લાયસન્સ ઉપરોક્ત અધિનિયમની જોગવાઈઓ અને તે હેઠળ બનેલા નિયમો
              અનુસાર સસ્પેન્ડ અથવા રદ થઈ શકે છે.
            </p>

            <p className="mb-3">
              4. આ લાયસન્સ સસ્પેન્શન અથવા રદ થવાના કિસ્સામાં, તેને ખેતીવાડી
              ઉત્પન્ન બજાર સમિતિને સોંપવામાં આવશે. જો લાયસન્સ મોકુફ કે રદ થયું
              હશે તો વેપાર-ધંધો કરી શકાશે નહીં.
            </p>

            <p className="mb-3">
              5. લાયસન્સધારક આવા લાયસન્સ હેઠળ પોતાનો વ્યવસાય માત્ર અને માત્ર તે
              સ્થાનો પર જ ધંધો કરશે જેના માટે તેને લાઇસન્સ આપવામાં આવ્યું છે.
              લાયસન્સ ધંધાના સ્થળે જોઈ શકાય તે રીતે લટકાવવાનું રહેશે.
            </p>

            <p className="mb-3">
              6. પરવાનેદારે સંબંધિત બજાર સમિતિને નિર્ધારિત બજાર ફી અને સુપરવિઝન
              ચાર્જ ચૂકવવા પડશે.
            </p>

            <p className="mb-3">
              7. લાઇસન્સધારક, ખેતીવાડી ઉત્પન્ન બજાર સમિતિને બજાર ફીની થતી ચોરી
              અટકાવવામાં મદદ કરશે. તેમજ બજારધારાની જોગવાઈઓના અમલીકરણની
              કાર્યવાહીમાં મદદ કરશે.
            </p>

            <p className="mb-3">
              8. લાયસન્સધારકે, ખેતીવાડી ઉત્પન્ન બજર સમિતિ દ્વારા તેને લાઇસન્સ
              આપ્યાની તારીખથી પંદર દિવસની અંદર, તેને લાઇસન્સધારકના અધિકૃત
              પ્રતિનિધિ વિશેની માહિતી પ્રદાન કરવી જોઈએ જે તેના વતી જવાબદાર હશે.
            </p>

            <p className="mb-3">
              9. લાયસન્સધારક, ખેતીવાડી ઉત્પન્ન બજાર સમિતિ દ્વારા નિર્ધારીત
              પુસ્તકો, રજિસ્ટરો અને રેકોર્ડની જાળવણી કરવી પડશે અને તે ખેતીવાડી
              ઉત્પન્ન બજાર સમિતિ અથવા તેમના દ્વારા અધિકૃત વ્યક્તિને નિરીક્ષણ
              માટે ઉપલબ્ધ કરાવવી જોઈશે.
            </p>

            <p className="mb-3">
              10. લાઇસન્સધારકે ખેતીવાડી ઉત્પન્ન બજાર સમિતિ દ્વારા માંગેલ તમામ
              માહિતી પૂરી પાડવી પડશે.
            </p>

            <p className="mb-3">
              11. લાયસન્સધારક, બજાર સમિતિના પેટા-નિયમો હેઠળ આપવામાં આવેલી રીત
              અનુસાર કૃષિ પેદાશોના ભાવ પતાવટ કરશે અને નિયમોની જોગવાઈઓ અનુસાર
              ખાતાની સ્લિપ અથવા ખરીદીના બિલ જારી કરશે. નિયત નમૂનાની બિલ બુકો
              સબંધીત બજાર સમિતિ પાસે પ્રમાણીત કરાવવાની રહેશે.
            </p>

            <p className="mb-3">
              12. લાઇસન્સધારકે, જો તેણે કૃષિ પેદાશોનું વેચાણ તેની એજન્સી દ્વારા
              અથવા તેના દ્વારા કરવામાં આવ્યું હોવાનું જાહેર કર્યું હોય, તો તે જ
              દિવસે વેચવામાં આવેલ કૃષિ પેદાશોની કિંમત વેચનારને આપવી જોઈએ. માલ
              વેચાણ કિંમત નક્કી થયા પછી ભાવમાં ફેરફાર કરી શકાશે નહીં.
            </p>

            <p className="mb-3">
              13. લાયસન્સ ધારક અધિનિયમની જોગવાઈઓ તેના હેઠળ બનાવેલા નિયમો અને
              પેટા-નિયમો અનુસાર જે તે ફી મેળવવા અથવા વસૂલ કરવા માટે હકદાર છે તે
              સિવાય કોઈપણ ફીની માંગણી કે પ્રાપ્તી કરી શકશે નહીં અથવા કોઈપણ ચાર્જ
              વસૂલ કરશે નહીં.
            </p>

            <p className="mb-3">
              14. લાયસન્સ ધારક કોઈપણ વેપાર ભથ્થું બનાવશે નહીં કે વસૂલ કરશે નહીં.
            </p>

            <p className="mb-3">
              15. લાઇસન્સ ધારક અધિકૃત વજન અને માપ માટે પ્રદાન કરશે.
            </p>

            <p className="mb-3">
              16. લાયસન્સધારકે લાયસન્સ ધરાવતા તોલમાપ અને માપ લેનાર અને હમાલને
              માત્ર ખેતિવાડી ઉત્પન્ન બજાર સમિત દ્વારા મંજૂર કરાયેલા દરો પર જ
              ચૂકવણી કરવી પડશે.
            </p>

            <p className="mb-3">
              17. વેપાર હેઠળની ખેતપેદાશોની સુરક્ષા/સલામતી હેતુ લાયસન્સ ધારકે
              અગ્નીશામક સાધનો/સી.સી.ટી.સી કેમેરાની સુવિધા રાખવાની રહેશે.
            </p>

            <p className="mb-3">
              18. સબંધીત બજાર સમિતિના પેટા નિયમો, વખતોવખતની સુચનાઓનું લાયસન્સ
              ધારકે પાલન કરવાનું રહેશે.
            </p>

            <p className="mb-3">
              19. લાઇસન્સધારક લાયસન્સના બંધારણમાં કોઈપણ ફેરફાર અંગે ખેતીવાડી
              ઉત્પન્ન બજાર સમિતિને જાણ કરશે.
            </p>

            <p className="mb-3">
              20. લાયસન્સધારકને, ગુજરાત ખેત ઉત્પન્ન અને ખરીદ-વેચાણ (ઉત્તેજન અને
              સરલીકરણ) અધિનિયમ, ૧૯૬૩ અને ગુજરાત એગ્રીકલ્ચર માર્કેટ રૂલ્સ, ૧૯૬૫,
              કૃષિ પેદાશોના માર્કેટિંગના સંબંધમાં તમામ વિવાદોના સંદર્ભમાં
              બંધનકર્તા રહેશે.
            </p>
          </div>
        </div>

        {/* Date and Place */}
        <div className="mb-2">
          <div className="d-flex justify-content-between align-items-center">
            <div className="text-start">
              <div className="d-flex mb-2">
                <span className="fw-bold" style={{ width: "64px" }}>તારીખ:</span>
                <span className="flex-fill ps-1">.......................................</span>
              </div>
              <div className="d-flex">
                <span className="fw-bold" style={{ width: "64px" }}>સ્થળ:</span>
                <span className="flex-fill ps-1">.......................................</span>
              </div>
            </div>

            <div className="text-center ms-3" style={{ minWidth: 220 }}>
              <p className="fw-bold mb-1">સેક્રેટરી</p>
              <p className="fw-bold mb-0">ખેતીવાડી ઉત્પન્ન બજાર સમિતિ , {application?.apmc ? application.apmc : "........"}</p>
            </div>
          </div>
        </div>

        {/* Renewal Section */}
       {/* <div className="pt-3">
  <h2 className="fw-bold mb-4 mt-3 text-dark" style={{ fontSize: "16px" }}>
    લાયસન્સનું નવીકરણ
  </h2>

  <table className="table table-bordered w-100">
    <thead>
      <tr>
        <th className="fw-bold border p-2 bg-transparent text-center">રીન્યુઅલ તારીખ</th>
        <th className="fw-bold border p-2 bg-transparent text-center">રીન્યુઅલ સમયગાળો</th>
        <th className="fw-bold border p-2 bg-transparent text-center">સેક્રેટરીની સહી અને તારીખ</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td className="border p-2" style={{ height: "28px" }}></td>
        <td className="border p-2" style={{ height: "28px" }}></td>
        <td className="border p-2" style={{ height: "28px" }}></td>
      </tr>
      <tr>
        <td className="border p-2" style={{ height: "28px" }}></td>
        <td className="border p-2" style={{ height: "28px" }}></td>
        <td className="border p-2" style={{ height: "28px" }}></td>
      </tr>
    </tbody>
  </table>
</div> */}

      </div>

      {/* Download button */}
      <button
        className="bg-success rounded text-white px-4 py-2"
        onClick={handleDownloadPDF}
        disabled={loading}
      >
        {loading ? "Downloading..." : "1. Download License"}
      </button>
    </div>
  );
};

export default GcaLicenseDownload;
